<!--
  Global toast owned by ErrorInterceptor. Pages declare their own <p-toast> with inconsistent
  keys (some unkeyed, some "t1"/"t2"), so server-side validation errors need a target that
  exists on every route. The dedicated key keeps it from competing with page-level toasts.
-->
<p-toast position="top-right" key="apiValidation"></p-toast>
<router-outlet></router-outlet>
